















import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';

@Component({})
export default class ActionBarButton extends Vue {
  @Prop({ default: true }) private isDisabled!: boolean;
  @Prop() private width!: string;
}
